export function sampleRows(rows, limit) {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (limit <= 0) return [];
  if (safeRows.length <= limit) return safeRows;
  const stride = Math.ceil(safeRows.length / limit);
  const sampled = [];
  for (let i = 0; i < safeRows.length; i += stride) sampled.push(safeRows[i]);
  return sampled;
}
